import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./WelcomeTweetModal.css";

const TWEET_ID = "2021551278707687594";

export const WelcomeTweetModal = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [tweetLoaded, setTweetLoaded] = useState(false);
  const mountRef = useRef(null);
  const renderedRef = useRef(false);

  const close = () => setShow(false);

  useEffect(() => {
    if (
      location.pathname.includes("/admin") ||
      location.pathname.includes("admin-login") ||
      location.pathname.includes("super-admin-login") ||
      location.pathname.includes("waqar-login")
    ) return;
    setShow(true);
  }, []);

  useEffect(() => {
    if (!show || renderedRef.current) return;
    renderedRef.current = true;

    const renderTweet = () => {
      if (!window.twttr || !window.twttr.widgets || !mountRef.current) return;
      window.twttr.widgets
        .createTweet(TWEET_ID, mountRef.current, {
          align: "center",
          dnt: true,
          conversation: "none",
        })
        .then(() => setTweetLoaded(true));
    };

    if (window.twttr && window.twttr.widgets) {
      renderTweet();
    } else {
      const s = document.createElement("script");
      s.src = "https://platform.twitter.com/widgets.js";
      s.async = true;
      s.charset = "utf-8";
      s.onload = renderTweet;
      document.head.appendChild(s);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="wtm-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="wtmTitle"
      onClick={(e) => { if (e.target === e.currentTarget) close(); }}
    >
      <div className="wtm-card">

        <div className="wtm-head">
          <button className="wtm-close" onClick={close} aria-label="Close">&#10005;</button>
          <div className="wtm-head-inner">
            <span className="wtm-badge">&#127942; Featured Recognition</span>
            <h2 className="wtm-title" id="wtmTitle">
              Ranked <span>Top Trader</span> on WEEX
            </h2>
            <p className="wtm-desc">
              Official recognition from WEEX for outstanding trading performance — see the announcement below.
            </p>
          </div>
        </div>

        <div className="wtm-body">
          <div className="wtm-tweet" ref={mountRef}>
            {!tweetLoaded && (
              <div className="wtm-loading">
                <div className="wtm-spinner"></div>
                <span>Loading tweet…</span>
              </div>
            )}
          </div>
        </div>

        <div className="wtm-foot">
          <span className="wtm-cred">Waqar Zaka &middot; Award-Winning Trading Team</span>
          <div className="wtm-actions">
            <a
              className="wtm-link"
              href="https://x.com/weex_official/status/2021551278707687594"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on X &#8599;
            </a>
            <button className="wtm-continue" onClick={close}>Continue to Site</button>
          </div>
        </div>

      </div>
    </div>
  );
};
